var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.556 456.556",
    style: {
      enableBackground: "new 0 0 456.556 456.556"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.544,124.364C23.573,124.364,0,100.795,0,71.819s23.573-52.545,52.544-52.545s52.541,23.569,52.541,52.545 S81.516,124.364,52.544,124.364z M52.544,46.131c-14.166,0-25.688,11.526-25.688,25.688s11.522,25.688,25.688,25.688 c14.162,0,25.685-11.526,25.685-25.688S66.707,46.131,52.544,46.131z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.128,85.248H167.932c-7.417,0-13.428-6.015-13.428-13.428s6.011-13.428,13.428-13.428h275.196 c7.417,0,13.428,6.015,13.428,13.428S450.545,85.248,443.128,85.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.544,280.822C23.573,280.822,0,257.253,0,228.278s23.573-52.544,52.544-52.544s52.541,23.569,52.541,52.544 S81.516,280.822,52.544,280.822z M52.544,202.59c-14.166,0-25.688,11.526-25.688,25.688c0,14.162,11.522,25.688,25.688,25.688 c14.162,0,25.685-11.526,25.685-25.688C78.229,214.116,66.707,202.59,52.544,202.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.128,241.706H167.932c-7.417,0-13.428-6.015-13.428-13.428s6.011-13.428,13.428-13.428h275.196 c7.417,0,13.428,6.015,13.428,13.428S450.545,241.706,443.128,241.706z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.544,437.281C23.573,437.281,0,413.712,0,384.737c0-28.975,23.573-52.544,52.544-52.544s52.541,23.569,52.541,52.544 C105.086,413.712,81.516,437.281,52.544,437.281z M52.544,359.048c-14.166,0-25.688,11.526-25.688,25.688 c0,14.162,11.522,25.688,25.688,25.688c14.162,0,25.685-11.526,25.685-25.688C78.229,370.574,66.707,359.048,52.544,359.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.128,398.165H167.932c-7.417,0-13.428-6.015-13.428-13.428c0-7.413,6.011-13.428,13.428-13.428h275.196 c7.417,0,13.428,6.015,13.428,13.428C456.556,392.15,450.545,398.165,443.128,398.165z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/Options.c99af9d9.svg";
export { ForwardRef as ReactComponent };